import {
  ProductGroupTag,
  TagContainer,
  UniclassClassificationCodeTag
} from 'portal/components/RecordsModules/common/StyledComponents'
import { Tooltip } from 'antd'

type DeliveryProductWithGroup = {
  productGroups: Array<{
    productGroupId: string
    name: string
  }> | null
  isHiredOrRented: boolean
  uniclassClassificationCode: string | null
  uniclassClassificationDescription: string | null
}

export function DeliveryProductTag({
  item
}: {
  item: DeliveryProductWithGroup
}) {
  return (
    <TagContainer>
      {item.productGroups && item.productGroups[0] && (
        <ProductGroupTag key={item.productGroups[0].productGroupId}>
          {item.productGroups[0].name}
        </ProductGroupTag>
      )}
      {item.uniclassClassificationCode && (
        <Tooltip
          title={`Uniclass ${item.uniclassClassificationCode}${
            item.uniclassClassificationDescription
              ? ` ${item.uniclassClassificationDescription}`
              : ''
          }`}
        >
          <UniclassClassificationCodeTag>
            {item.uniclassClassificationCode}
          </UniclassClassificationCodeTag>
        </Tooltip>
      )}
    </TagContainer>
  )
}
